import { Colaborador } from '../../../interfaces/colaborador.interface';
import styles from './CardColaborador.module.scss';
import editar from '../../../assets/img/icons/btn-Editar.svg';
import excluirIcon from '../../../assets/img/icons/btn-Excluir.svg';

interface CardColaboradorProps {
    colaborador: Colaborador;
    onClick: (data: Colaborador) => void;
    excluir: (id: string) => void;
}

const CardColaborador: React.FC<CardColaboradorProps> = ({ colaborador, onClick, excluir }) => {
    return (
        <div className={styles.container}>
            <h3>{colaborador.nome}</h3>
            <p><strong>Função:</strong> {colaborador.funcao}</p>
            <p><strong>Comunidade:</strong> {colaborador.comunidade}</p>
            <p><strong>Sexo:</strong> {colaborador.sexo}</p>

            <div className={styles.botoes}>
                <button className={styles.btn} onClick={() => onClick(colaborador)}>
                    {/* <img src={editar} alt="Editar" /> */}
                </button>

                <button className={styles.btn} onClick={() => excluir(colaborador.id)}>
                    <img src={excluirIcon} alt="Excluir" />
                </button>
            </div>
        </div>
    );
};

export default CardColaborador;
